import { ApiError } from '../../api/errors';
import { config } from '../../config';

/**
 * Calls one of the API's open endpoints (the fit check) from a public page. Same base URL and error shape as the
 * portal's client (api/client.ts), but it never attaches a token and never loads supabase-js. Gives up after
 * `timeoutMs` so a stalled request turns into an error the page can explain.
 */
export async function publicPost<T>(path: string, body: unknown, { timeoutMs = 15_000 }: { timeoutMs?: number } = {}): Promise<T> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(`${config.apiUrl}${path}`, {
      method: 'POST',
      headers: { accept: 'application/json', 'content-type': 'application/json' },
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    const text = await res.text();
    let json: unknown;
    try {
      json = text ? JSON.parse(text) : undefined;
    } catch {
      json = undefined;
    }
    if (!res.ok) {
      const e = (json ?? {}) as { error?: string; message?: string };
      throw new ApiError(res.status, e.error ?? 'error', e.message ?? `Request failed (${res.status})`);
    }
    return json as T;
  } finally {
    clearTimeout(timer);
  }
}
